import styled from '@emotion/styled/macro';
import TextLoader from 'components/TextLoader';

const AppLoader = styled(TextLoader)`
  position: fixed;
  inset: 0;
`;

export default AppLoader;
